// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14cdo","signatureBlock":"Footer_signatureBlock__2w-wD","signature":"Footer_signature__1ma8h"};